export const printInvoice = (saleData) => {
    const shopName = localStorage.getItem('company_name') || 'Smart Shop';
    const logoUrl = localStorage.getItem('company_logo');
    const billNote = localStorage.getItem('bill_note') || '';
    const billBarcodeEnabled = localStorage.getItem('bill_barcode_enabled') !== 'false';
    const shopPhone = localStorage.getItem('shop_phone') || '';
    const shopAddress = localStorage.getItem('shop_address') || '';
    
    // saleData should have: invoice_number, customer_name, items, final_amount, paid_amount, due_amount, date
    const items = saleData.items || [];
    const itemsHtml = items.map(item => `
        <tr>
            <td style="padding:4px 2px;font-size:12px;">${item.product_name || item.name}</td>
            <td style="padding:4px 2px;font-size:12px;text-align:center;">${item.quantity}</td>
            <td style="padding:4px 2px;font-size:12px;text-align:right;">Rs.${parseFloat(item.unit_price || item.price).toFixed(2)}</td>
            <td style="padding:4px 2px;font-size:12px;text-align:right;">Rs.${parseFloat(item.total_price || ((item.price - (item.discount||0)) * item.quantity)).toFixed(2)}</td>
        </tr>
    `).join('');

    const invoiceNumber = saleData.invoice_number || 'N/A';
    
    const printWindow = window.open('', '_blank', 'width=350,height=700');
    printWindow.document.write(`
        <html>
            <head>
                <title>Receipt - ${invoiceNumber}</title>
                ${billBarcodeEnabled ? '<script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.6/dist/JsBarcode.all.min.js"><\/script>' : ''}
                <style>
                    body { font-family: 'Courier New', Courier, monospace; width: 80mm; margin: 0 auto; padding: 10px; color: #000; }
                    .header { text-align: center; margin-bottom: 10px; }
                    .logo { max-width: 60px; margin-bottom: 5px; }
                    h3 { margin: 0; text-transform: uppercase; font-size: 16px; }
                    .shop-subtitle { font-size: 9px; color: #555; margin-top: 2px; }
                    hr { border: none; border-top: 1px dashed #000; margin: 10px 0; }
                    table { width: 100%; border-collapse: collapse; }
                    th { text-align: left; font-size: 11px; border-bottom: 1px dashed #000; padding: 5px 0; }
                    .center { text-align: center; }
                    .right { text-align: right; }
                    .bold { font-weight: bold; }
                    .footer { text-align: center; margin-top: 15px; font-size: 11px; }
                    .details { font-size: 12px; margin-bottom: 10px; }
                    .barcode-section { text-align: center; margin: 10px 0 5px; }
                    .bill-note { text-align: center; font-size: 10px; margin-top: 8px; padding-top: 5px; border-top: 1px dashed #ccc; color: #555; }
                    .powered-by { text-align: center; font-size: 9px; color: #999; margin-top: 10px; }
                </style>
            </head>
            <body>
                <div class="header">
                    ${logoUrl ? `<img src="${logoUrl}" class="logo" onerror="this.style.display='none'" />` : ''}
                    <h3>${shopName}</h3>
                    ${shopAddress ? `<div class="shop-subtitle">${shopAddress}</div>` : ''}
                    ${shopPhone ? `<div class="shop-subtitle">Tel: ${shopPhone}</div>` : ''}
                </div>
                <hr/>
                <div class="details">
                    <strong>Invoice:</strong> ${invoiceNumber}<br/>
                    <strong>Date:</strong> ${new Date(saleData.date || Date.now()).toLocaleString()}<br/>
                    <strong>Customer:</strong> ${saleData.customer_name || 'Walk-in'}<br/>
                    ${saleData.customer_phone ? `<strong>Phone:</strong> ${saleData.customer_phone}` : ''}
                </div>
                <hr/>
                <table>
                    <thead>
                        <tr>
                            <th style="width: 40%;">Item</th>
                            <th style="width: 15%; text-align: center;">Qty</th>
                            <th style="width: 20%; text-align: right;">Price</th>
                            <th style="width: 25%; text-align: right;">Total</th>
                        </tr>
                    </thead>
                    <tbody>${itemsHtml}</tbody>
                </table>
                <hr/>
                <div class="right bold" style="font-size: 14px; margin-top: 5px;">
                    Total: Rs.${parseFloat(saleData.final_amount).toFixed(2)}
                </div>
                <div class="right" style="font-size: 12px;">
                    Paid: Rs.${parseFloat(saleData.paid_amount).toFixed(2)}
                </div>
                ${parseFloat(saleData.due_amount) > 0 ? `
                    <div class="right bold" style="font-size: 12px; color: #000;">
                        Due: Rs.${parseFloat(saleData.due_amount).toFixed(2)}
                    </div>
                ` : ''}
                ${billBarcodeEnabled ? `
                <div class="barcode-section">
                    <svg id="invoice-barcode"></svg>
                </div>
                ` : ''}
                <hr/>
                <div class="footer">
                    Thank you for your business!<br/>
                    Please visit again.
                </div>
                ${billNote ? `<div class="bill-note">${billNote}</div>` : ''}
                <div class="powered-by">Powered by appy.pk</div>
                <script>
                    window.onload = function() {
                        ${billBarcodeEnabled ? `
                        try {
                            if (typeof JsBarcode !== 'undefined') {
                                JsBarcode("#invoice-barcode", "${invoiceNumber}", {
                                    format: "CODE128",
                                    width: 1.5,
                                    height: 30,
                                    displayValue: true,
                                    fontSize: 10,
                                    margin: 5,
                                    background: "#ffffff",
                                    lineColor: "#000000"
                                });
                            }
                        } catch(e) { console.error('Bill barcode error:', e); }
                        ` : ''}
                        setTimeout(function() {
                            window.print();
                            window.onafterprint = function() {
                                window.close();
                            };
                        }, 500);
                    };
                <\/script>
            </body>
        </html>
    `);
    printWindow.document.close();
};
